module.exports = __webpack_public_path__ + "img/earth.adfe3928.svg";